import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[lfwmsTemplateRef]'
})
export class TemplateRefDirective {

  constructor(public templateRef: TemplateRef<any>) {}

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/directives/template-ref.directive.ts